/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Constant imports.
 */
import { PRODUCT_TYPE_CONSTANT } from '../../constants/app.constants';

/**
 * Event View Certificate Component
 */
@Component({
  selector: 'app-event-view-certificate',
  templateUrl: './event-view-certificate.component.html',
  styleUrls: ['./event-view-certificate.component.scss']
})
export class EventViewCertificateComponent implements OnInit, OnDestroy {


  @Input() data;
  @Output() resetSkpModal = new EventEmitter();
  @Input() vaultObj;

  public isSkpModalShown = true;
  public confirmAction = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public certificateType: any;
  public mediaModal = false;
  public openMediaIndex = 0;
  public mediaObj = [];
  public course_id = '';
  public hasChanged = false;
  public screen_name = 'generate_certificate';

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances
   */
  constructor(
    public dss: DataStorageService,
    private postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    public multiLangService: MultiLangService,
    public fcs: FunCollectionService,
    public masterService: MasterserviceService,
    public mls: NewLanguageService) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    const stringToSplit = this.vaultObj.certificate_url;
    if (stringToSplit != null && stringToSplit != '') {
      const x = stringToSplit.split('.');
      this.certificateType = x[x.length - 1];
    }
  }

  /**
   * product Share
   */
  productShare(): void {
    const x = [{ share_url: '', share_contentt: this.vaultObj.share_content, product_type: PRODUCT_TYPE_CONSTANT.SESSION, product_type_id: this.vaultObj.event_id }];
    this.fcs.productShare(x);
  }
  /**
   * show Modal
   */
  showModal(): void {
    this.isSkpModalShown = true;
  }

  /**
   * hide Modal
   */
  hideModal(): void {
    this.isSkpModalShown = false;
    this.resetSkpModal.emit(0);
  }

  /**
   * onHidden
   */
  onHidden(): void {
    this.isSkpModalShown = false;
    this.resetSkpModal.emit(0);
  }

  /**
   * view Certificate
   */
  viewCertificate(): void {
    this.mediaModal = false;
    if (this.vaultObj.certificate_url != '' && this.vaultObj.certificate_url != undefined) {
      this.mediaObj = [];
      const t = {
        media_id: 1,
        media_name: 'certificate',
        media_thumbnail: '',
        media_type: 'document',
        media_url: this.vaultObj.certificate_url
      };
      this.mediaObj.push(t);
      this.mediaModal = true;
      this.hasChanged = !this.hasChanged;


      this.mediaModal = true;
    } else {
      this.subscriptions.add(this.postSer.generateCmeCertificate(this.vaultObj.course_id).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.vaultObj.certificate_url = data['data'].pdf_url;
            const stringToSplit = this.vaultObj.certificate_url;
            if (stringToSplit != null && stringToSplit != '') {
              const x = stringToSplit.split('.');
              this.certificateType = x[x.length - 1];
            }
            this.mediaObj = [];
            const t = {
              media_id: 1,
              media_name: 'certificate',
              media_thumbnail: '',
              media_type: 'document',
              media_url: this.vaultObj.certificate_url
            };
            this.mediaObj.push(t);
            this.mediaModal = true;
            this.hasChanged = !this.hasChanged;
          } else {
            this.fcs.errorHandeler(data, this.screen_name);
            return;
          }
        });
      }));
    }
  }

  /**
   * set Reset Media Modal
   */
  setResetMediaModal(val, indx): void {
    if (indx == undefined) {
      this.openMediaIndex = 0;
    }
    this.mediaModal = val;
    if (indx != '' && indx != undefined) { this.openMediaIndex = indx; }
  }

  /**
   * download Certificate
   */
  downloadCertificate(): void {
    // Blank function
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}

